import ReactGA from "react-ga";

if (process.env.REACT_APP_ENV === "production") {
  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;

  if (trackingId) ReactGA.initialize(trackingId);
}
